export default {
  breadcrumbs: 'Menu/Smarter IoT Dashboard',
  menu1: 'Smarter City',
  menu2: 'Teaching Source',
  menu3: 'Leaerning Activity',
  menu4: 'Inter-Class Service',
}